import { getGlobalSelector } from './mmd';

const getRoot = () => getGlobalSelector().additionalSelectors.menu;

export const getMenuRoutes = () => getRoot().getMenuRoutes();
export const menuSelectors = () => getRoot().menuSelectors();
